import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {MBulkGiftVoucherCustomer} from '../model/m-bulk-gift-voucher-customer-dto';
import {HttpClient} from '@angular/common/http';
import {AppSettings} from '../../../settings/app-settings';

@Injectable()
export class MBulkGiftVoucherCustomerService {

  constructor(private http: HttpClient) {
  }

  //save bulk gift voucher customer
  public save(mBulkGiftVoucherCustomer: MBulkGiftVoucherCustomer): Observable<MBulkGiftVoucherCustomer> {
    return this.http.post<MBulkGiftVoucherCustomer>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/master-files/m-bulk-gift-voucher-customer/save", mBulkGiftVoucherCustomer);
  }

  //get bulk gift voucher customers
  public findAll(): Observable<MBulkGiftVoucherCustomer[]> {
    return this.http.get<MBulkGiftVoucherCustomer[]>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/master-files/m-bulk-gift-voucher-customer/find-all");
  }

  public delete(indexNo: number): Observable<number> {
    return this.http.delete<number>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-bulk-gift-voucher-customer/delete/' + indexNo);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher-bulk-customer/service/m-gift-voucher-customer.service.ts